/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CloudAccount {
    getFixupPrototypeFunction() { return CloudAccount.fixupPrototype; }

    static newInstance(model: Partial<CloudAccount>): CloudAccount {
        let obj = Object.assign(new CloudAccount(), model);
        CloudAccount.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CloudAccount>): CloudAccount {
        if (!model) return null;
        return CloudAccount.newInstance(<CloudAccount> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CloudAccount) {
        if (!obj) return;

        models.CloudAccount.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CloudAccount): boolean {
        Object.setPrototypeOf(obj, CloudAccount.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Displays the cloud associated with the template, for example, AWS, GCP, Azure etc
     */
    cloud: string;

    /**
     * Unique Identifier of the cloud account onboarded in the on boarding section
     */
    cloud_account_id: string;

    /**
     * The region of the cloud account where it needs to be executed. Mandatory for AWS
     */
    region: string;

    /**
     * The zones of the cloud account where it needs to be executed. Mandatory for GCP
     */
    zones: string;

    /**
     * Resource group for which you need to execute the template for. Mandatory for Azure
     */
    resourcegroup: string;

    /**
     * Location under which you need to execute the template for. Mandatory for Azure
     */
    location: string;

}
